import { css } from '@emotion/css';

export const addButtonStyles = css`
  .MuiButton-startIcon {
    margin: 0;
  }
`;
